import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const notificationPreferencesUpdateMutationAtom =
  createMutationAtomFactory(
    'notifications.preferencesUpdate',
    (params: {
      input: Array<{
        notificationTypeKey: string;
        channel: string;
        enabled: boolean;
      }>;
    }) => ({
      notificationPreferencesUpdate: {
        __args: {
          input: params.input,
        },
        id: true,
        notificationTypeKey: true,
        channel: true,
        enabled: true,
      },
    }),
  );
